module.exports = __webpack_public_path__ + "img/available-location-opacity.e53ed85e.svg";